import { maticGetAbi, maticGetAbiFunctions, maticGetTxStatus, maticNftCreateColelction, maticNftMint, maticNftVerify, maticTokenCreate, maticTokenSmartContractInteraction, maticTokenVerify, maticTransferToken } from "./axiosRequests/axiosHandlerMatic";
import { Chain } from "./Chain";
import { MaticNftVerify, TokenSmartContractInteraction } from "./models";
import { MaticNftCreateColelction } from "./models/modelsMaticNft/MaticNftCreateCollection";
import { MaticNftMint } from "./models/modelsMaticNft/MaticNftMint";
import { MaticGetTxStatus } from "./models/modelsMaticSmartContract/maticCheckStatus";
import { MaticGetAbi } from "./models/modelsMaticSmartContract/maticGetAbi";
import { MaticGetAbiFunctions } from "./models/modelsMaticSmartContract/maticGetAbiFunctions";
import { MaticTokenCreate } from "./models/modelsMaticToken/MaticTokenCreate";
import { MaticTokenVerify } from "./models/modelsMaticToken/MaticTokenVerify";
import { MaticTransferToken } from "./models/modelsMaticToken/MaticTransferToken";

export class Polygon extends Chain { 

    public polygonCreateToken = async (
        payload: MaticTokenCreate
    ): Promise<any> => {
        return await maticTokenCreate(payload, this.initialize);
    }

    public polygonTranferToken = async (
        payload: MaticTransferToken
    ): Promise<any> => {
        return await maticTransferToken(payload, this.initialize);
    }

    public polygonVerifyToken = async (
        payload: MaticTokenVerify
    ): Promise<any> => {
        return await maticTokenVerify(payload, this.initialize);
    }

    public polygonVerifyNft = async (
        payload: MaticNftVerify
    ): Promise<any> => {
        return await maticNftVerify(payload, this.initialize);
    }

    public polygonNftCreate = async (
        payload: MaticNftCreateColelction
    ): Promise<any> => {
        return await maticNftCreateColelction(payload, this.initialize);
    }


    public polygonMintNft = async (
        payload: MaticNftMint
    ): Promise<any> => {
        return await maticNftMint(payload, this.initialize);
    }
     
    public polygonAbiFunctions = async (
        payload: MaticGetAbiFunctions
    ): Promise<any> => {
        return await maticGetAbiFunctions(payload, this.initialize);
    }

    public polygonGetAbi = async (
        payload: MaticGetAbi
    ): Promise<any> => {
        return await maticGetAbi(payload, this.initialize);
    }

    public polygonGetTxStatus = async (
        payload: MaticGetTxStatus
    ): Promise<any> => {
        return await maticGetTxStatus(payload, this.initialize);
    }

    // public establishConnection = async (networkProvider: any): Promise<any> => {
    //     // "https://data-seed-prebsc-1-s1.binance.org:8545"
    //     return new Web3(new Web3.providers.HttpProvider(networkProvider))
    // }

    // public signTransaction = async (
    //     rawTransaction: any,
    //     web3: any,
    //     privateKey: any
    // ): Promise<any> => {
    //     const decryptedAccount = web3.eth.accounts.privateKeyToAccount(
    //         privateKey
    //     )
    //     return await decryptedAccount.signTransaction(rawTransaction)
    // }

    // public sendTransaction = async (signedTx: any, web3: any): Promise<any> => {
    //     await web3.eth
    //         .sendSignedTransaction(signedTx.rawTransaction)
    //         .then((receipt: any) =>
    //             console.log('Transaction receipt: ', receipt)
    //         )
    // }
    public maticTokenContractInteract = async (payload: TokenSmartContractInteraction): Promise<any> => {
        return await maticTokenSmartContractInteraction(payload, this.initialize);
     }
}